import { Alert, Typography } from "@mui/material";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

/**
 * CommonError displays a standardized error message.\
 *
 * Intended use is for showing a visually consistent error alert in the application when
 * an error occurs.
 */
export const CommonError: FC = () => {
  const { t } = useTranslation();
  return (
    <Alert severity="error">
      <Typography
        sx={({ palette }) => ({
          color: palette.error.main,
        })}
      >
        {t("Error.somethingWentWrong")}
      </Typography>
      <Typography
        sx={({ palette }) => ({
          color: palette.error.main,
        })}
      >
        {t("Error.anErrorHasOccurred")}
      </Typography>
    </Alert>
  );
};
